import { on } from './eventListener/on';
import { componentNodeMap, getComponentNode } from './componentNodeMap';
import { getHotAreaNode } from './hotAreaNodeMap';

export const ACTION_TRIGGER_PREFIX = '__impage_action_trigger_';

export function generateComponentActionParams(action, instance, global, meta) {
  const { data, key, trigger } = action;

  return {
    key,
    data,
    triggerEventType: trigger.replace(ACTION_TRIGGER_PREFIX, ''),
    trigger: {
      type: 'component',
      component: getComponentData(instance),
    },
    meta,
    global,
    componentsMap: componentNodeMap,
    getComponentByKey: getComponentNode,
  };
}

export function generateHotareaActionParams(action, hotArea, component, global, meta) {
  const params = generateComponentActionParams(action, component, global, meta);
  params.trigger.type = 'hotarea';
  params.trigger.hotarea = getHotAreaData(hotArea, component);
  return params;
}

export function generatePluginParams(plugin, global, meta) {
  const { key, data } = plugin;
  return {
    key,
    data,
    meta,
    global,
    on,
    componentsMap: componentNodeMap,
    getComponentByKey: getComponentNode,
  };
}

export function generatePluginEventListenerCallbackParams(eventType, global, meta, component, hotArea) {
  const componentData = getComponentData(component);
  const hotAreaData = hotArea ? getHotAreaData(hotArea, component) : undefined;

  return {
    meta,
    global,
    triggerEventType: eventType,
    trigger: {
      type: hotArea ? 'hotarea' : 'component',
      component: componentData,
      hotarea: hotAreaData,
    },
    component: componentData,
    hotArea: hotAreaData,
  };
}

export function getComponentData({ key, component: { id, info, name, projId, projKey } }) {
  return {
    key,
    id,
    info,
    name,
    projId,
    projKey,
    get node() {
      return getComponentNode(key);
    },
  };
}

export function getHotAreaData({ key, position, size }, component) {
  return {
    key,
    position,
    size,
    parent: getComponentData(component),
    get node() {
      return getHotAreaNode(key);
    },
  };
}
